import React from 'react'

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Profile from './pages/Profile';
import Confirmation from './pages/Confirmation';
import Payment from './pages/Payment';
import Logout from './pages/Logout';
import Skills from './pages/Skills';
import Printout from './pages/Printout';
import Invoice from './pages/Invoice';
import ChangeSkill from './pages/portal/change-skill';
import ChangeCourse from './pages/portal/change-course/change-course';
import Certificate from './pages/portal/certificate';
import ChangePassword from './pages/portal/password';
import Dashboard from './pages/portal/Dashboard';
import Complaints from './pages/portal/complaints/Complaints';
const ProtectedView =()=> {
  return (
    <>
       
        <Routes>
        <Route  path="/app/profile" element={<Profile /> } /> 
        <Route  path="/app/confirmation" element={<Confirmation /> } /> 
        <Route  path="/app/made_payment" element={<Payment /> } /> 
        <Route  path="/app/get_printout/:code" element={<Printout /> } /> 
        <Route  path="/app/skills" element={<Skills /> } /> 
        <Route  path="/app/invoice" element={<Invoice /> } /> 
        <Route  path="/app/dashboard" element={<Dashboard /> } /> 
        <Route  path="/app/portal/certificate" element={<Certificate /> } />
        <Route  path="/app/portal/change-skill" element={<ChangeSkill /> } /> 
        <Route  path="/app/portal/change-course" element={<ChangeCourse /> } />  
{/*         <Route  path="/app/portal/password" element={<ChangePassword /> } /> */}
        <Route  path="/app/portal/complaints" element={<Complaints /> } />
        <Route  path="/logout" element={<Logout /> } />
        <Route  path="*" element={<div>Page Not Found</div>} /> 

        </Routes>
        </>
  )
}

export default ProtectedView